










































































import {
  FormTemplate,
  FormTemplateFieldError,
  IFormSectionData,
  IFormTemplateData
} from '@/models';
import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { ALForm } from '@/common/component.types';

import { mapActions } from 'vuex';
import { ErrorManager } from '@/models/error';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

const baseMixins = mixins(auth);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'FormTemplateDialog',
    components: {
      ALDialog,
      ErrorAlert
    },
    data() {
      return {
        dialog: false,
        loading: false,
        formValid: false,

        errorMessage: '',
        detailErrorMessage: '',

        templateData: {} as IFormTemplateData,

        fieldError: new FormTemplateFieldError()
      };
    },
    methods: {
      ...mapActions({
        createFormTemplate: 'formTemplate/createFormTemplate'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open() {
        this.resetFormValidation();
        this.templateData = {
          sections: [
            {
              title: 'Section 1',
              order: 0,
              section_fields: []
            } as IFormSectionData
          ]
        } as IFormTemplateData;
        this.dialog = true;
      },

      close() {
        this.dialog = false;
      },

      save() {
        this.clearAllErrors();
        if (this.validateForm()) {
          this.loading = true;
          const template = new FormTemplate(this.templateData);

          this.createFormTemplate(template)
            .then(data => this.routeToTemplatePage(data.id))
            .catch(error => {
              if (error.response) {
                if (error.response.data.detail) {
                  this.errorMessage = error.response.data.detail;
                }

                if (
                  FormTemplateFieldError.isFormTemplateFieldErrorData(
                    error.response.data
                  )
                ) {
                  this.fieldError = new FormTemplateFieldError(
                    error.response.data
                  );
                }
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },

      routeToTemplatePage(templateId: number) {
        this.$router.push({
          name: 'form-template-detail',
          params: {
            id: String(templateId)
          }
        });
      },

      clearAllErrors() {
        this.errorMessage = '';
        this.detailErrorMessage = '';
        this.fieldError.clearErrors();
      }
    }
  });
